<div class="rounded-[10px] bg-white p-5 filters-shadow">
  <div class="flex flex-col gap-6 pt-5">
    <div class="grid grid-cols-4 gap-6">
      <app-filter-input
        [label]="isArabic() ? 'اسم السبب' : 'Reason Name'"
        [placeholder]="isArabic() ? 'ابحث باسم السبب...' : 'Search by reason name'"
        type="text"
        [(value)]="reasonName" />

      <div class="col-span-3"></div>
    </div>

    <div class="grid grid-cols-4 gap-6">
      <app-filter-date-component
        [label]="isArabic() ? 'تاريخ الإنشاء (من)' : 'Created On (From)'"
        [value]="createdOnFrom()"
        (valueChange)="createdOnFrom.set($event)"
        [isInvalid]="createdDateInvalid()" />

      <app-filter-date-component
        [label]="isArabic() ? 'تاريخ الإنشاء (إلى)' : 'Created On (To)'"
        [value]="createdOnTo()"
        (valueChange)="createdOnTo.set($event)"
        [isInvalid]="createdDateInvalid()" />

      <app-filter-date-component
        [label]="isArabic() ? 'آخر تعديل (من)' : 'Last Modified (From)'"
        [value]="lastModifiedOnFrom()"
        (valueChange)="lastModifiedOnFrom.set($event)"
        [isInvalid]="lastModifiedDateInvalid()" />

      <app-filter-date-component
        [label]="isArabic() ? 'آخر تعديل (إلى)' : 'Last Modified (To)'"
        [value]="lastModifiedOnTo()"
        (valueChange)="lastModifiedOnTo.set($event)"
        [isInvalid]="lastModifiedDateInvalid()" />
    </div>

    @if (createdDateInvalid()) {
      <p class="text-[12px] text-red-500">
        {{
          isArabic()
            ? "تاريخ البداية للإنشاء لا يمكن أن يكون بعد تاريخ النهاية."
            : "Created From date cannot be after Created To date."
        }}
      </p>
    }

    <div class="border_Color my-5 flex items-end justify-between border-t pt-5">
      <app-filter-sorting-component
        [orderBy]="filters().orderBy!"
        (orderByChange)="onOrderByChange($event)"
        [orderDir]="filters().orderDir!"
        [sortOptions]="sortOptions()"
        (toggleOrder)="onToggleSortOrder()" />

      <div class="flex gap-3">
        <button
          (click)="onResetFilters()"
          class="borderTabsColor textTabsColor hover-bg-primary-10 rounded-[6px] border px-6 py-1.5 text-[13px] font-[500] hover:cursor-pointer">
          <span i18n="@@ppReasonsResetButton">Clear</span>
        </button>
        <button
          (click)="onApplyFilters()"
          class="bgTabsColor hover:bgHoverPrimaryColor rounded-[6px] px-6 py-1.5 text-[13px] font-[500] text-white hover:cursor-pointer">
          <span i18n="@@ppReasonsApplyButton">Apply</span>
        </button>
      </div>
    </div>
  </div>
</div>
